import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";

import { isIndexableHost } from "./canonical-host";

/**
 * Detecta si la petición actual llega por el subdominio del panel privado.
 * `createIsomorphicFn` separa las dos implementaciones: la del servidor (y su
 * import de `@tanstack/react-start/server`) se elimina del bundle de cliente.
 */
export const detectIndexableHost = createIsomorphicFn()
  .client((): boolean => isIndexableHost(window.location.hostname))
  .server((): boolean => {
    try {
      const host = getRequest()?.headers.get("host") ?? "";
      return isIndexableHost(host);
    } catch {
      return false;
    }
  });
